import { Search as SearchIcon } from "@mui/icons-material";
import { Button } from "@mui/material";
import { ModalOpenButton } from "@msys/ui";
import { useTranslate } from "@tolgee/react";
import { ProductPreferencesSearchModal } from "../modals/ProductPreferencesSearchModal.js";
import { ProductSearchModal } from "../modals/ProductSearchModal.js";

interface Props {
  /** The product type whose search to open; `null` opens the unfiltered search global preferences rank. */
  productTypeId: string | null;
}

/** Opens the product search the preferences rank, so their effect can be seen on its results. */
export function PreferenceSearchButton({ productTypeId }: Props) {
  const { t } = useTranslate(["Product"]);

  const button = (
    <Button size="small" variant="outlined" startIcon={<SearchIcon />}>
      {t("Show in search", { ns: "Product" })}
    </Button>
  );

  return productTypeId !== null ? (
    <ModalOpenButton
      Modal={ProductPreferencesSearchModal}
      modalProps={{ productTypeId, includePreferences: true }}
    >
      {button}
    </ModalOpenButton>
  ) : (
    <ModalOpenButton
      Modal={ProductSearchModal}
      modalProps={{
        title: t("Global preferences", { ns: "Product" }),
        enableLandingPage: false,
      }}
    >
      {button}
    </ModalOpenButton>
  );
}
